import { render, staticRenderFns } from "./IconSvgGif.vue?vue&type=template&id=2d3365b6&scoped=true&"
import script from "./IconSvgGif.vue?vue&type=script&lang=js&"
export * from "./IconSvgGif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3365b6",
  null
  
)

export default component.exports